import intlTelInput from "intl-tel-input";
import PlacesAutocomplete from "../place.autocomplete";
import Cookies from "js-cookie";
import axios from "axios";

require('sumoselect');

require('jquery-steps/build/jquery.steps');

$(document).ready(function () {
  $("#wizard").steps({
    headerTag: "h2",
    bodyTag: "section",
    transitionEffect: "fade",
    enableAllSteps: true,
    transitionEffectSpeed: 500,
    labels: {
      finish: "Submit",
      next: "Next",
      previous: "Back"
    },
    onStepChanging: 	function (event, currentIndex, newIndex) {
      let errorCounter =  0;
      // validation for current index 0
      if(currentIndex === 0){

        let assist_course = $('#assist_course');
        let assist_course_val = assist_course.val();

        if(assist_course_val.length){
          assistantRemoveErrorMessage(assist_course);
        }else{
          assistantAddErrorMessage(assist_course);
        }

        let assist_course_programs = $('#assist_course_programs');
        let assist_course_programs_val = parseInt(assist_course_programs.val());

        // console.log(assist_course_programs_val, 'assist_course_programs_val')
        if(!assist_course_programs_val) {
          errorCounter++;
          assistantAddErrorMessage(assist_course_programs);

        }else{
          assistantRemoveErrorMessage(assist_course_programs);
        }

      /*if(assist_course_programs_val.length){
          assistantRemoveErrorMessage(assist_course_programs);
        }else{
          errorCounter++;
          assistantAddErrorMessage(assist_course_programs);
        }*/

        let assist_course_dur = $('#assist_course_dur');
        let assist_course_dur_val = assist_course_dur.val();

        if(assist_course_dur_val.length){
          assistantRemoveErrorMessage(assist_course_dur);
        }else{
          errorCounter++;
          assistantAddErrorMessage(assist_course_dur);
        }

        let assist_class = $('#assist_class');
        let assist_class_val = assist_class.val();

        if(assist_class_val.length){
          assistantRemoveErrorMessage(assist_class);
        }else{
          errorCounter++;
          assistantAddErrorMessage(assist_class);
        }

        let assist_subjects = $('#assist_subjects');
        let assist_subjects_val = assist_subjects.val();

        if(assist_subjects_val.length){
          assistantRemoveErrorMessage(assist_subjects);
        }else{
          errorCounter++;
          assistantAddErrorMessage(assist_subjects);
        }
      }

      // console.log(errorCounter, 'errorCounter');
      if(errorCounter === 0){
        return true;
      }

      return false;
    },
    onStepChanged: function(event, currentIndex, priorIndex){

      if(currentIndex === 1){
        const PlacesAutocompleteConfig = {
          placeHolder: "Search for Place...",
          debounce: 1000,
          suggestionApiUrl: `${HOST + API_PATH}/places-suggestion`,
          infoApiUrl: `${HOST + API_PATH}/places-info`
        }

        // search location
        if(!$('#assist_search_location').closest('.autoComplete_wrapper').length){
          const AssistSearchAddressLPA = new PlacesAutocomplete({...PlacesAutocompleteConfig, selector: "#assist_search_location"});
          addEventOnChangeLocation(AssistSearchAddressLPA, '#searchGeoLocation');
        }

        // home location
        /*if(!$('#assist_home_location').closest('.autoComplete_wrapper').length){
          const AssistHomeAddressLPA = new PlacesAutocomplete({...PlacesAutocompleteConfig, selector: "#assist_home_location"});
          addEventOnChangeLocation(AssistHomeAddressLPA, '#homeGeoLocation');
        }*/

        /**
         * add country flags and country codes on input for mobile
         * @type {Element}
         */
        const input = document.querySelector(".assist_mobile");
        intlTelInput(input, {
          initialCountry: "in",
          separateDialCode: true,
          nationalMode: true
        });




      }

    },
    onFinished: async function (event, currentIndex) {

      if(!$('#otpWrapper').hasClass('sr-only')){
        $('[href="#finish"]').text('Verify OTP');
      }

      let form = document.getElementById('wizard');
      let formData = new FormData(form);

      let assist_mobile_number = $('#assist_mobile_number');
      let assist_your_name = $('#assist_your_name');
      let assist_search_location = $('#assist_search_location');
      let assist_search_location_val = assist_search_location.val();
     /* let assist_home_location = $('#assist_home_location');
      let assist_home_location_val = assist_home_location.val();*/
      let USER_DATA = {};
      USER_DATA.mobile = assist_mobile_number.val();
      USER_DATA.role = 'PARENT';
      USER_DATA.name = assist_your_name.val();

      //==========search query parameters
      let course_type = `course_type=${encodeURIComponent(formData.get('course_programs'))}`;
      let grades = `&eligibility[]=${encodeURIComponent(formData.get('grade'))}`;
      let subjects = formData.getAll('subjects[]').map(function(v){
        return `&subject[]=${encodeURIComponent(v)}`;
      })
      subjects = subjects.join('');

      let courses_duration =`&course_duration=${encodeURIComponent(formData.get('courses_duration'))}`
      /*let courses_duration = formData.getAll('courses_duration[]').map(function(v){
        return `&course_duration[]=${v}`;
      })*/
      // courses_duration = courses_duration.join('');
      // let home_location = `&home_location=${encodeURIComponent(formData.get('home_location'))}`;
      let search_location = `&search_location=${encodeURIComponent(formData.get('search_location'))}`;
      //==========/search query parameters

      /*console.log(`${HOST}/search?${course_type}${courses_duration}${subjects}${grades}`)
      return false;*/

      if (localStorage.getItem('parent_info')) {
        await redirectToSearch(form);
      } else {
        if ($('#otpWrapper').hasClass('sr-only')) {
          let errorCounter = 0;

          if(USER_DATA.mobile.length === 10){
            assistantRemoveErrorMessage(assist_mobile_number);
          }else{
            errorCounter++;
            assistantAddErrorMessage(assist_mobile_number);
          }

          if(USER_DATA.name.length){
            assistantRemoveErrorMessage(assist_your_name);
          }else{
            errorCounter++;
            assistantAddErrorMessage(assist_your_name);
          }

          /*if(assist_home_location_val.length){
            assistantRemoveErrorMessage(assist_home_location);
          }else{
            errorCounter++;
            assistantAddErrorMessage(assist_home_location);
          }*/

          if(assist_search_location_val.length){
            assistantRemoveErrorMessage(assist_search_location);
          }else{
            errorCounter++;
            assistantAddErrorMessage(assist_search_location);
          }

          if(errorCounter !== 0){
            return false;
          }

          USER_DATA.country_code = $('#mobileWrapper').find('.iti__selected-dial-code').text();
          axios.post(`${HOST + API_PATH}/parent/login`, USER_DATA).then(res => {
            $('#otpWrapper').removeClass('sr-only');
            $('[href="#finish"]').text('Verify OTP');
          }).catch(err => {
            console.log(err);
          });
        }else{
          let assist_otp =  $('#assist_otp');
          USER_DATA.otp = assist_otp.val();

          if(USER_DATA.otp.length === 4){
            axios.post(`${HOST + API_PATH}/parent/login-with-otp`, USER_DATA).then(response => {
              Cookies.set('jwt_parent_access_token', response.data.access_token, {expires: 7, path: '/'});
              localStorage.setItem('parent_info', JSON.stringify(response.data.user_info));
              // $('#assistModal').modal('hide');
              $('#webLoginBtn').removeClass('d-inline-block').addClass('d-none');
              $('#webLogoutBtn').removeClass('d-none').addClass('d-inline-block');
            }).then(() => {
              axios.post(`${HOST + API_PATH}/parent/create-assist-lead`, formData).then(async res => {
                sessionStorage.setItem('hideAssistant', true);
                await redirectToSearch(form);
                // $('#assistModal').modal('hide');
              }).catch(err => {
                console.log(err);
              });
            } ).catch(err => {
              $('#otpStatus').removeClass('text-success').addClass('text-danger').text(err.response.data.msg);
            })
          }else{
            assistantAddErrorMessage(assist_otp);
          }
      }
      }
    }
  });

  $('.wizard > .steps li a').click(function(){
    $(this).parent().addClass('checked');
    $(this).parent().prevAll().addClass('checked');
    $(this).parent().nextAll().removeClass('checked');
  });

  // Custome Jquery Step Button
  $('.forward').click(function(){
    $("#wizard").steps('next');
  });

  $('.backward').click(function(){
    $("#wizard").steps('previous');
  });

  // Select Dropdown
  $('html').click(function() {
    $('.select .dropdown').hide();
  });

  $('.select').click(function(event){
    event.stopPropagation();
  });

  $('.select .select-control').click(function(){
    $(this).parent().next().toggle();
  });
  $('.select .dropdown li').click(function(){
    $(this).parent().toggle();
    let text = $(this).attr('rel');
    $(this).parent().prev().find('div').text(text);
  });

  $('#assist_course').on('change', function(e){
    e.stopPropagation();
    let courseId = $('#assist_course').val();
    const ASSIST_COURSE_PROGRAMS = $('#assist_course_programs');
    const ASSIST_COURSE_PROGRAMS_PROGRAMS  = $('#assist_course_programs_wrapper');
    // ASSIST_COURSE_PROGRAMS_PROGRAMS.hide();
    // console.log('this is event');
    if(courseId){
      assistLoaderShow();
      axios.post(`${HOST + API_PATH}/get-course-programs`, {courseId}).then(res => {
        let options = '<option value="0">Select Course Type</option>';
        let data = res.data;
        ASSIST_COURSE_PROGRAMS.empty();
        ASSIST_COURSE_PROGRAMS_PROGRAMS.hide();
        if(data.length){
          for(let x of data){
            options+=`<option value="${x['id']}">${x['name']}</option>`
          }
          ASSIST_COURSE_PROGRAMS.html(options);
          ASSIST_COURSE_PROGRAMS[0].sumo.reload();
          ASSIST_COURSE_PROGRAMS_PROGRAMS.show();
        }else{
          ASSIST_COURSE_PROGRAMS.html(`<option value="${courseId}" selected>${courseId}</option>`);
          ASSIST_COURSE_PROGRAMS[0].sumo.reload();
        }

        // subjects

        let formData = new FormData();
        formData.append('courseId', courseId);
        axios.post(HOST + API_PATH + '/get-course-subjects', formData).then( response => {

          const SUBJECTS_SELECT_BOX = $('#assist_subjects');
          const SUBJECTS_SELECT_BOX_WRAPPER = $('#assist_subjects_wrapper');
          // SUBJECTS_SELECT_BOX_WRAPPER.hide();
          let options = '';
          let data = response.data;
          SUBJECTS_SELECT_BOX.empty();

          for (let x in data) {
            options += `<option value="${x}">${data[x]}</option>`
          }
          SUBJECTS_SELECT_BOX.html(options);
          SUBJECTS_SELECT_BOX[0].sumo.reload();
          // SUBJECTS_SELECT_BOX_WRAPPER.show();

          assistLoaderHide();

        }).catch( err => {console.log(err)});



      }).catch(err => {
        // ASSIST_COURSE_PROGRAMS[0].sumo.unSelectAll();
        ASSIST_COURSE_PROGRAMS[0].sumo.removeAll();
        console.log(err);
      })
    }

  });

  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#assist_course').on('change', function(e){
      console.log('this one');
      $(this).trigger('sumo:closed');
    })
  }


  /**
   * run course type api on modal show only first time
   */
  $('#assistModal').on('shown.bs.modal', function(e){

    /*===================Sumo select====================*/
    $('#assist_course').SumoSelect();
    // $('#assist_course_programs').SumoSelect({search: true, searchText: 'Enter here.'});
    $('#assist_course_programs').SumoSelect();
    // console.log($('.assist_course_programs')[0].sumo);
    $('#assist_course_dur').SumoSelect({selectAll: true});
    $('#assist_subjects').SumoSelect({selectAll: true, captionFormatAllSelected: 'All {0} selected!', placeHolder: 'Select here'});
    $('#assist_class').SumoSelect({selectAll: true});
    /*===================/Sumo select====================*/

    if ($('#assist_course_type option') !== null) {
      $('#assist_course').trigger('change');
    }

    /*=================== hide login inputs when login====================*/
    if (localStorage.getItem('parent_info') !== null ) {
      $('#assist_wrapper').addClass('sr-only');
    }


  });

  /**
   * resend otp
   */
  $('#assist_resend_otp').on('click', function(e){
    e.preventDefault();
    const FORM_DATA = new FormData();
    let assist_mobile_number = $('#assist_mobile_number');
    FORM_DATA.append('role', 'PARENT');
    FORM_DATA.append('mobile', assist_mobile_number.val());

    if(FORM_DATA.get('mobile').length < 10){
      assistantAddErrorMessage(assist_mobile_number);
      return false;
    }

    axios.post(HOST+ API_PATH + '/parent/resend-otp', FORM_DATA).then((response) => {
      $('#otpStatus').removeClass('text-danger').addClass('text-success').text(response.data.msg);
    }).catch(err => {
      $('#otpStatus').removeClass('text-success').addClass('text-danger').text(err.response.data.msg);
      console.log(err);
    })

  });


});

function assistantAddErrorMessage(selector){
  assistantRemoveErrorMessage(selector);
  selector.parent().after(`<span class="small text-danger alert-error">Required Field*</span>`);
}
function assistantRemoveErrorMessage(selector){
  selector.parent().next('.alert-error').remove();
}


function addEventOnChangeLocation(addressLPA, searchGeoLocation){
  addressLPA.input.addEventListener('change', () => {
    console.log('this one is event');
    const {googleAutocomplete: {address_components = [], geometry: {location} = {}} = {}} = addressLPA;

    console.log(location, 'geometry');

    if (location && typeof location !== "undefined"){
      $(searchGeoLocation).val(JSON.stringify(location));
    };

    // let {long_name: city} = address_components.find(({types}) => types.includes("administrative_area_level_2")) || {};
    // let {long_name: state} = address_components.find(({types}) => types.includes("administrative_area_level_1")) || {};
    // let {long_name: country} = address_components.find(({types}) => types.includes("country")) || {};
    // let {long_name: postal_code} = address_components.find(({types}) => types.includes("postal_code")) || {};
    //
    // if (city && typeof city !== "undefined") $('#addressCity').val(city);
    // if (state && typeof state !== "undefined") $('#addressState').val(state);
    // if (country && typeof country !== "undefined") $('#addressCountry').val(country);
    // if (postal_code && typeof postal_code !== "undefined") $('#addressPostal').val(postal_code);

  });
}

window.redirectToSearch = async (form) =>{
  $(form).find('[name="search_location"]').removeAttr('name');
  $(form).find('[name="search_location_geo"]').removeAttr('name');
  $(form).find('[name="home_location"]').removeAttr('name');
  $(form).find('[name="home_location_geo"]').removeAttr('name');
  $(form).find('[name="name"]').removeAttr('name');
  $(form).find('[name="mobile"]').removeAttr('name');
  $(form).find('[name="otp"]').removeAttr('name');
  $(form).find('[name="course"]').removeAttr('name');

  $(form).find('[name="subjects[]"]').attr('name','subject[]');
  $(form).find('[name="course_programs"]').attr('name','course_type');
  $(form).find('[name="grade"]').attr('name','eligibility[]');
  $(form).find('[name="courses_duration"]').attr('name','course_duration');

  let queryStr = $(form).serialize();

  window.location.href = `${HOST}/search?${queryStr}`;
}

window.assistLoaderShow = () => {
  $('#assistLoader').addClass('d-flex').removeClass('d-none');
}

window.assistLoaderHide = () => {
  $('#assistLoader').removeClass('d-flex').addClass('d-none');
}
